// extracted by mini-css-extract-plugin
export default {"container":"Message_container__DLFmp"};